import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  background-color: #f8feff;
  box-shadow: 0 2px 12px 0px rgba(0,0,0,0.15);
  border-radius: 10px;
  padding: 13px 20px;
  border: 1px solid #3087be;
  margin: 15px 0;
`;

const Link = styled.a`
  -moz-appearance: none;
  -webkit-appearance: none;
  background: none;
  border: none;
  outline: none;
  &::-moz-focus-inner {
    border: 0;
  }
  &:focus {
    outline: none;
  }

  all: initial;
  text-decoration: none;
  font-weight: bold !important;
  margin-top: 7px;
  display: inline-block;
  font-size: 16px !important;
  color: #0086C2;
  cursor: pointer;
  border-bottom: 1px solid transparent;
  padding-top: 3px;
  padding-bottom: 3px;
  line-height: 25px;

  &:hover{
    color: #11A9CE;
    border-bottom: 1px solid #11A9CE;
  }
`;

const LinkText = styled.span`
  padding: 7px 0px;
  &::-moz-focus-inner {
    border: 0;
  }
  &:focus {
    outline: none;
  }
`;

const Paragraph = styled.p`
  all: initial;
  font-size: 15px !important;
  font-weight: 500 !important;
  line-height: 24px !important;
  display: block;
  color: #404040 !important;
  font-family: Montserrat !important;
  margin-bottom: 10px !important;
`;

const KnowMore = () => (
  <Container>
    <Paragraph>Want to know more about recycling?</Paragraph>
    <Link tabIndex="0" href="https://recyclecoach.com/residents/blog/" target="_blank">
      <LinkText tabIndex="-1">
        Visit our library.
      </LinkText>
    </Link>
  </Container>
);

export default KnowMore;
